import { render } from "./DesignSystem.vue?vue&type=template&id=06b2801e&scoped=true"
import script from "./DesignSystem.vue?vue&type=script&lang=js"
export * from "./DesignSystem.vue?vue&type=script&lang=js"

import "./DesignSystem.vue?vue&type=style&index=0&id=06b2801e&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b2801e"]])

export default __exports__